
import { processedUrl } from '@padlet/vivaldi-client'
import { observeIntersection } from 'bits/intersection'
import { Component, namespace, State, Vue, Watch } from 'bits/vue'
import type { SearchResultDataCollectionMap } from 'bits/web_search'
import {
  AudioSearchResult,
  ImageSearchResult,
  SearchFilters,
  VideoSearchResult,
  WebSearchResult,
} from 'bits/web_search'
import OzLoadingSpinner from 'library/v4/components/OzLoadingSpinner.vue'
import BaseButton from 'vuecomponents/base_button.vue'
import ContentPickerSearchResultsAv from 'vuecomponents/content-picker-search-results-av.vue'
import ContentPickerSearchResultsImage from 'vuecomponents/content-picker-search-results-image.vue'
import ContentPickerSearchResultsWeb from 'vuecomponents/content-picker-search-results-web.vue'
import WebBrowserAttribution from 'vuecomponents/web_browser_attribution.vue'

@Component({
  components: {
    BaseButton,
    ContentPickerSearchResultsWeb,
    ContentPickerSearchResultsImage,
    ContentPickerSearchResultsAv,
    WebBrowserAttribution,
    OzLoadingSpinner,
  },
})
export default class ContentPickerSearchResults extends Vue {
  $refs!: {
    resultBody: HTMLDivElement
  }
  // From JoyPixels
  EMOJIS = {
    '1f626': {
      code: '1f626',
      category: 'people',
      shortname: ':frowning:',
      name: 'frowning face with open mouth',
      keywords: ['face', 'frown', 'mouth', 'open'],
      url: `https://padlet.net/icons/png/1f626.png`,
    },
    '1f633': {
      code: '1f633',
      category: 'people',
      shortname: ':flushed:',
      name: 'flushed face',
      keywords: ['dazed', 'face', 'flushed'],
      url: `https://padlet.net/icons/png/1f633.png`,
    },
    '1f634': {
      code: '1f634',
      category: 'people',
      shortname: ':sleeping:',
      name: 'sleeping face',
      keywords: ['face', 'sleep', 'zzz'],
      url: `https://padlet.net/icons/png/1f634.png`,
    },
  }
  SearchFilters = SearchFilters
  isNoResults = false

  @State isOnline
  @namespace('contentPicker').Getter searchQuery!: string
  @namespace('contentPicker').Getter searchFilter!: SearchFilters
  @namespace('contentPicker').Getter isSearchQueryInProgress!: boolean
  @namespace('contentPicker').Getter isSearchMoreQueryInProgress!: boolean
  @namespace('contentPicker').Getter isError!: boolean
  @namespace('contentPicker').Getter allResults!: Record<string, Record<SearchFilters, SearchResultDataCollectionMap[]>>
  @namespace('contentPicker').Getter currentSearchResultsForFilter!: (
    | AudioSearchResult
    | WebSearchResult
    | VideoSearchResult
    | ImageSearchResult
  )[]
  @namespace('contentPicker').Getter currentSearchMoreUrlForFilter!: string
  @namespace('contentPicker').Action search!: (payload: { query?: string; url?: string }) => void
  @namespace('contentPicker').Action searchMore!: (payload?: { query?: string }) => void
  @namespace('contentPicker').Action clearSearchError!: () => void
  get results(): (AudioSearchResult | WebSearchResult | VideoSearchResult | ImageSearchResult)[] {
    return this.currentSearchResultsForFilter
  }

  get canSearchMore(): boolean {
    return !!this.currentSearchMoreUrlForFilter
  }

  processedIconUrl(icon: object & { url: string }): string {
    return processedUrl(icon.url, { width: 64, height: 64, preset: 'icon' })
  }

  @Watch('results')
  addSearchMoreTrigger(): void {
    this.$nextTick(() => {
      // necessary to wait for the element to appear
      const searchMoreTrigger = document.querySelector('#search-more-trigger') as HTMLDivElement
      if (searchMoreTrigger) {
        observeIntersection(searchMoreTrigger, () => {
          this.triggerSearchMore()
        })
      }
    })
  }

  @Watch('isSearchQueryInProgress')
  @Watch('searchFilter')
  checkIfNoResults(): void {
    let xResults = true
    if (this.searchQuery) {
      xResults = this.results && this.results.length > 0
    }
    this.isNoResults = !xResults
  }

  @Watch('searchFilter')
  scrollToTopWhenFilterChanges(): void {
    if (!this.$refs.resultBody) return
    this.$refs.resultBody.scrollTop = 0
  }

  @Watch('isOnline')
  backOnline(): void {
    this.clearSearchError()
  }

  select(data: string): void {
    this.$emit('select', data)
  }

  triggerSearchMore(): void {
    this.searchMore()
  }
}
